import { ColumnsWitdhType, DatasetItem } from '../../../../types/types';

export const getVisibleColumnsWidth = (
  columnsWidth: ColumnsWitdhType,
  items: DatasetItem[] | undefined
): ColumnsWitdhType => {
  if (!columnsWidth || !items) return columnsWidth;
  const visibleNames = new Set(
    items.filter((item) => item.visible !== false).map((item) => item.name)
  );
  return Object.fromEntries(
    Object.entries(columnsWidth).filter(([name]) => visibleNames.has(name))
  );
};
